import React, { useState, ChangeEvent, FormEvent, useEffect } from "react";
import QuestionAddPopup from "./QuestionAddPopup";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { IQuestion, IQuestionTab } from "../../interfaces/Question";
import {
  questionFrequencies,
  questionsInitial,
} from "../../constants/Questions";
import {
  fetchQuestions,
  storeQuestions,
  deleteQuestion,
  resetState,
} from "../../store/ProgramQuestions";
import { ToastContentProps, toast } from "react-toastify";
import { Icon } from "../AccordionIcon";


const Question: React.FC<IQuestionTab> = ({ programId }) => {
  const dispatch = useDispatch<any>();
  const [open, setOpen] = React.useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [questions, setQuestions] = useState<IQuestion[]>([]);
  const [questionToEdit, setQuestionToEdit] = useState<IQuestion | null>(null);
  const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);
  const storedData = localStorage.getItem("loginData");
  const {
    programQuestions: fetchedQuestions,
    loading,
    error,
  } = useSelector((state: RootState) => state.programQuestions);
  let accessToken = "";

  useEffect(() => {
    if (accessToken && !isLoggedIn) {
      // navigate('/');
    }
  }, [accessToken, isLoggedIn, navigator]);

  useEffect(() => {
    dispatch(resetState());
    if (programId) {
      dispatch(fetchQuestions({ programId }));
    }
  }, [dispatch]);

  useEffect(() => {
    setQuestions([...fetchedQuestions]);
  }, [fetchedQuestions]);

  useEffect(() => {
    if (questionToEdit !== null) {
      renderQuestions();
    }
    if (questions.length && questionToEdit === null) {
      setOpen(questions.length - 1);
    }
  }, [questions, questionToEdit]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        {loading && (
          <div
            className="border-t-4 border-solid h-16 w-16 border-b-4 border-r-4 border-l-4 rounded-full animate-spin"
            style={{ borderColor: "#B4804A" }}
          />
        )}
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!fetchedQuestions) {
    return <div>No data available</div>;
  }

  const handleOpen = (value: number) => setOpen(open === value ? 0 : value);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const updateQuestions = (question: IQuestion | null) => {
    if (questionToEdit) {
      setQuestions((prevQuestions) => {
        const questionsUpdated = prevQuestions.map((prevQuestion) => {
          if (prevQuestion.id === questionToEdit?.id) {
            return { ...prevQuestion, ...question };
          }
          return prevQuestion;
        });
        return questionsUpdated;
      });
    } else {
      setQuestions((prevQuestions) => [
        ...prevQuestions,
        question as IQuestion,
      ]);
    }
    closePopup();
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch(storeQuestions({ programId: programId as string, questions }))
      .then(() => {
        toast.success("Questions stored successfully");
      })
      .catch((err: { message: any }) => {
        if (err instanceof Error) {
          console.error(err.message);
        }
      });
  };

  const handleDelete = (index: number, questionId: string | undefined) => {
    const newQuestions = [...questions];
    newQuestions.splice(index, 1);
    setQuestions(newQuestions);
    if (questionId) {
      
      dispatch(deleteQuestion({ questionId }))
        .then(() => {
          toast.success("Question deleted successfully");
        })
        .catch((err: { message: any }) => {
          if (err instanceof Error) {
            console.error(err.message);
          }
        });
    }
  };

  const openEditQuestion = (question: IQuestion, index: number) => {
    setOpen(index);
    setIsPopupOpen(true);
    setQuestionToEdit(question);
  };

  const renderQuestions = () => {
    return questions.map((question, index) => (
      <Accordion
        key={index}
        open={open === index}
        icon={<Icon id={index} open={open} />}
      >
        <AccordionHeader
          onClick={() => handleOpen(index)}
          className="bg-[#041B44] text-white px-6 py-2 rounded-t-xl flex-row mt-6 text-lg"
        >
          <span>Question {index + 1}</span>
        </AccordionHeader>
        <AccordionBody className="p-6 border rounded-b-xl">
          <div className="absolute top-3 end-20">
            <button
              type="button"
              className="w-fit pl-4 hover:border-gray-800"
              role="menuitem"
              onClick={(e) => openEditQuestion(question, index)}
            >
              <img
                src="./images/EditWhite.png"
                alt=""
                className="w-[75%]"
              />
            </button>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(index, question.id);
              }}
              className="pl-2"
              role="menuitem"
            >
              <img
                src="./images/deleteWhite.png"
                alt=""
                className="w-[75%]"
              />
            </button>
          </div>
          <div className="flex flex-row justify-between">
            <div className="">
              <p className="text-[18px]">{question.text}</p>
            </div>
            <div className="">
              <select
                disabled={true}
                id="questionType"
                className="text-[#657F8B] font-gilroy px-3 py-2 border border-1 w-[120px] border-[#E7EFF3] rounded-full bg-[#FAFBFD]"
                required
                value={question?.frequency as string}
              >
                <option value="">Please select a question type</option>
                {questionFrequencies.map((questionFrequency, index) => {
                  return (
                    <option key={index} value={questionFrequency}>
                      {questionFrequency}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          {question.options && (
            <div key={index} className="mt-4 relative flex items-center gap-2">
              {question.options.map((option, index) => (
                <span
                  key={index}
                  className="font-gilroy bg-[#F5F7F8] text-[#657F8B] font-medium me-2 px-6 border  py-3 rounded-full border-1 border-[#E7EFF3]"
                >
                  {option.title}
                </span>
              ))}
            </div>
          )}
        </AccordionBody>
      </Accordion>
    ));
  };

  return (
    <div className="px-8 pb-2 max-h-[calc(100vh-280px)] overflow-y-auto mt-2">
      <form
        name="storeQuestionsForm"
        id="storeQuestionsForm"
        onSubmit={handleSubmit}
      >
        {renderQuestions()}
        <button
          type="button"
          className="w-full object-cover mt-6 p-2 border-dashed text-[#8C97AC] rounded-lg border-2  border-[#8C97AC]"
          onClick={() => {
            setQuestionToEdit(null);
            openPopup();
          }}
        >
          <span className="flex flex-row justify-center text-lg  font-semibold text-center">
            <img src="./images/plusgray.png" alt="" />
            Add New Questions
          </span>
        </button>
        <button
          type="submit"
          className={`bg-[#B4804A] text-white float-right w-32 py-2 px-4 mb-8 mt-8 font-semibold rounded-md ${
            questions.length > 0 ? "cursor-pointer" : "cursor-not-allowed"
          }`}
          disabled={questions.length > 0 ? false : true}
        >
          Save
        </button>
      </form>
      {isPopupOpen && (
        <QuestionAddPopup
          closePopup={closePopup}
          updateQuestions={updateQuestions}
          questionToEdit={questionToEdit}
        />
      )}
    </div>
  );
};

export default Question;
